import { CandleInterval } from "./candle.types";

export function toBinanceInterval(interval: CandleInterval): string {
  return interval;
}

export function toBybitInterval(interval: CandleInterval): string {
  switch (interval) {
    case "1m":
      return "1";
    case "5m":
      return "5";
    case "15m":
      return "15";
    case "30m":
      return "30";
    case "1h":
      return "60";
    case "4h":
      return "240";
    case "1d":
      return "D";
  }
}

export function toGateInterval(interval: CandleInterval): string {
  return interval;
}

export function toKucoinGranularity(interval: CandleInterval): string {
  switch (interval) {
    case "1m":
      return "1";
    case "5m":
      return "5";
    case "15m":
      return "15";
    case "30m":
      return "30";
    case "1h":
      return "60";
    case "4h":
      return "240";
    case "1d":
      return "1440";
  }
}

export function toHyperliquidInterval(interval: CandleInterval): string {
  return interval;
}

